<div class="mable-section ion-margin-vertical">
  <mable-heading
    [heading]="props?.header?.level || 'h2'"
    [icon]="props?.header?.icon"
    >{{ props?.header?.text }}</mable-heading
  >
  <div class="sub-section ion-margin-horizontal">
    <p
      color="grey-500"
      *ngFor="let d of props?.description"
    >
      {{ d }}
    </p>

    <div class="controls">
      <ion-grid class="no-padding">
        <ion-row>
          <ion-col *ngFor="let btn of props?.buttons">
            <mable-button
              expand="block"
              class="ion-no-margin"
              [category]="btn?.type || 'orange-500'"
              (onClick)="btn.handler($event)"
            >
              {{ btn.text }}
            </mable-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
</div>
